import Header from '../components/Header'
import Footer from '../components/Footer'
import { Shield, Lock, Eye, AlertTriangle } from 'lucide-react'

const SecurityPage = () => {
  const features = [
    {
      icon: <Shield className="h-8 w-8 text-orange-600" />,
      title: 'Bank-Level Security',
      description: 'MobiPay is built on bank-grade security infrastructure, ensuring your payment data is handled with the highest level of protection and integrity.'
    },
    {
      icon: <Lock className="h-8 w-8 text-orange-600" />,
      title: 'End-to-End Encryption',
      description: 'All data transmitted through our platform is encrypted using 256-bit SSL/TLS encryption, protecting your information from interception.'
    },
    {
      icon: <Eye className="h-8 w-8 text-orange-600" />,
      title: 'Fraud Detection',
      description: 'Our advanced AI-powered fraud detection system monitors transactions in real-time, flagging and blocking suspicious activity before it impacts your business.'
    },
    {
      icon: <AlertTriangle className="h-8 w-8 text-orange-600" />,
      title: 'Incident Response',
      description: 'Our dedicated security team is available 24/7 to respond to any security incidents and ensure minimal disruption to your operations.'
    }
  ]

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <section className="gradient-bg text-white py-16">
        <div className="container-max section-padding text-center">
          <h1 className="text-4xl font-bold mb-4">Security</h1>
          <p className="text-blue-100 text-lg max-w-2xl mx-auto">Your security is our top priority. Learn how we protect your business and your customers.</p>
        </div>
      </section>
      <section className="py-16">
        <div className="container-max section-padding">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {features.map((feature, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
                <div className="inline-flex items-center justify-center w-14 h-14 bg-orange-50 rounded-xl mb-5">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
          <div className="mt-12 bg-white rounded-2xl p-10 shadow-sm border border-gray-100 max-w-5xl mx-auto">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Report a Security Issue</h2>
            <p className="text-gray-600 leading-relaxed mb-4">If you discover a security vulnerability, please report it responsibly to our security team. We take all reports seriously and will respond promptly.</p>
            <a href="mailto:support@mobipay.pk" className="inline-flex items-center text-orange-500 font-semibold hover:text-orange-600 transition-colors">
              support@mobipay.pk
            </a>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  )
}

export default SecurityPage
